export default __webpack_public_path__ + "static/media/label-cavalieri.a7d8163d.png";